




































































import { BaseButton } from '@bambeehr/pollen';
import { computed } from '@nuxtjs/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faFacebookF as FacebookIcon } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faTwitter as TwitterIcon } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faYoutube as YouTubeIcon } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faLinkedinIn as LinkedInIcon } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import useGlobalInfo from '@/hooks/useGlobalInfo';

export default {
  components: {
    BaseButton,
    FontAwesomeIcon,
  },
  props: {
    socialLinks: {
      type: Array,
      default: () => [
        {
          title: 'Facebook',
          icon: FacebookIcon,
          link: 'http://www.facebook.com/bambeeHQ/',
        },
        {
          title: 'Twitter',
          icon: TwitterIcon,
          link: 'http://www.twitter.com/BambeeHQ',
        },
        {
          title: 'YouTube',
          icon: YouTubeIcon,
          link: 'http://www.youtube.com/watch?v=rzJhkTm7baY&t=1s',
        },
        {
          title: 'LinkedIn',
          icon: LinkedInIcon,
          link: 'http://www.linkedin.com/company/bambee/',
        },
      ],
    },
    legalLinks: {
      type: Array,
      default: () => [
        {
          link: '/legal/privacy',
          text: 'Privacy Policy',
        },
        {
          link: '/legal/tos',
          text: 'Terms & Conditions',
        },
        {
          link: '/legal/retention',
          text: 'Retention Policy',
        },
      ],
    },
  },
  setup() {
    const year = computed(() => new Date().getFullYear());
    const { bambeeHours } = useGlobalInfo();

    return {
      year,
      bambeeHours,
    };
  },
};
